'use client'

import { EarnDashboard } from '@/containers/EarnDashboard'

export default function EarnPage() {
  return <EarnDashboard />
}
